'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'pen-swirl';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e214';
var svgPathData = 'M438.2 59.1L450.1 71c9.4 9.4 9.4 24.6 0 33.9L429 126.1 383.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM228.9 236.8L349.6 114.5 395.1 160 273.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L212 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM370 25.5L194.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.2-9.7 36.1-19.6L484.1 138.9c28.1-28.1 28.1-73.7 0-101.8L472.1 25.2C443.9-3.1 398-2.9 370 25.5zm-48.3-7.9C299.9 11.4 276.8 8 253 8C116 8 5 119 5 256S116 504 253 504c13.3 0 24-10.7 24-24s-10.7-24-24-24C142.5 456 53 366.5 53 256S142.5 56 253 56c9.8 0 19.3 .7 28.7 2l40-40.4zM451.1 228.4c1.2 9 1.9 18.2 1.9 27.6c0 57.4-46.6 104-104 104c-13.3 0-24 10.7-24 24s10.7 24 24 24c83.9 0 152-68.1 152-152c0-23.6-3.3-46.4-9.4-68l-40.4 40.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenSwirl = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;